import * as React from "react";
import useAsyncEffect from "@n1ru4l/use-async-effect";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import orderBy from "lodash-es/orderBy";

import "./styles.css";
import getCurrentPage from "../../model/currentpage";
import Select from "../select";
import SelectDateRange from "../date-and-time/select-date-range";
import RoomPrice from "../price/room-price";
import { getRoomKinds } from "../../model/rooms";
import find from "lodash-es/find";
import GuestsSelector from "../guests-selector";
import {
  getNumDays,
  DateType,
  GuestsType,
  pick,
  Moment
} from "../../model/utils";
import {
  setRoomDates,
  setNumRoomGuests,
  setRoomKind
} from "../../store/actions";
import { _ } from "../../model/utils";

function decodeHtml(html) {
  var txt = document.createElement("textarea");
  txt.innerHTML = html;
  return txt.value;
}

const mapStateToProps = pick([
  "roomDates",
  "numRoomGuests",
  "setNumRoomGuests",
  "roomKind",
  "setRoomKind",
  "dateRanges"
]);

const mapDispatchToProps = dispatch => ({
  setRoomDates: value => dispatch(setRoomDates(value)),
  setNumRoomGuests: value => dispatch(setNumRoomGuests(value)),
  setRoomKind: value => dispatch(setRoomKind(value))
});

const StayDataForm = ({
  roomDates,
  setRoomDates,
  numRoomGuests,
  setNumRoomGuests,
  roomKind,
  setRoomKind,
  dateRanges
}) => {
  const allowedDateRanges = dateRanges
    ? dateRanges.map(({ dateFrom, dateTo }) => [dateFrom, dateTo])
    : [];

  const [roomKinds, setRoomKinds] = React.useState([]);
  const [roomKindsEntries, setRoomKindsEntries] = React.useState([]);

  useAsyncEffect(
    function*() {
      const initialAvailableRoomKinds = orderBy(
        yield getRoomKinds(),
        ["title"],
        ["desc"]
      );
      console.log("DEB - initialAvailableRoomKinds", initialAvailableRoomKinds);
      const currentPage = yield getCurrentPage();
      console.log("DEB - currentPage", currentPage);
      const roomName =
        currentPage.ContentType === "Alloggio"
          ? decodeHtml(currentPage.Title)
          : null;
      console.log("DEB - done");
      const availableRoomKinds = roomName
        ? initialAvailableRoomKinds.filter(rk => rk.title === roomName)
        : initialAvailableRoomKinds;
      if (
        roomKindsSignature(availableRoomKinds) === roomKindsSignature(roomKinds)
      ) {
        return;
      }
      setRoomKinds(availableRoomKinds);
      setRoomKindsEntries(
        availableRoomKinds.sort().map(({ id, title }) => ({
          id,
          value: title
        }))
      );
      if (availableRoomKinds.length > 0) {
        setRoomKind(availableRoomKinds[0]);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [roomKindsSignature(roomKinds), setRoomKind]
  );

  const setRoomKindIdAndCheck = newRoomKindId => {
    // set the new room kind
    const newRoomKind = find(
      roomKinds,
      roomKind => roomKind.id === newRoomKindId
    );
    setRoomKind(newRoomKind);
    // if the current guests exceed the availability, reset it
    if (newRoomKind.maxGuests < numRoomGuests[0] + numRoomGuests[1]) {
      setNumRoomGuests([1, 0]);
    }
  };

  return (
    <div styleName="container">
      <div className="row">
        <div className="col-sm-6 col-lg-4">
          <div className="row">
            <div className="col-4">
              <div styleName="select-label">{_.numGuests}</div>
              <GuestsSelector
                fieldName="room_guests"
                numGuests={numRoomGuests}
                setNumGuests={setNumRoomGuests}
                disabled={!roomKind}
                maxGuests={roomKind ? roomKind.maxGuests : 0}
              />
            </div>
            <div className="col-8">
              <div styleName="select-label">{_.roomKind}</div>
              <Select
                fieldName="roomKind"
                entries={roomKindsEntries}
                id={roomKind ? roomKind.id : ""}
                setId={setRoomKindIdAndCheck}
              />
            </div>
          </div>
        </div>
        <div className="col-sm-6 col-lg-4 offset-lg-1">
          <SelectDateRange
            fieldName="room_day"
            room_days="experience_day"
            label={_.date}
            isDateRange={true}
            date={roomDates}
            setDate={setRoomDates}
            allowedDateRanges={allowedDateRanges}
          />
        </div>
        <div className="col-sm-12 col-lg-3">
          <RoomPrice
            numDays={getNumDays(roomDates)}
            numGuests={numRoomGuests[0] + numRoomGuests[1]}
            roomKind={roomKind}
          />
        </div>
      </div>
    </div>
  );
};

StayDataForm.propTypes = {
  roomDates: DateType,
  setRoomDates: PropTypes.func.isRequired,
  numRoomGuests: GuestsType.isRequired,
  setNumRoomGuests: PropTypes.func.isRequired,
  roomKind: PropTypes.object,
  setRoomKind: PropTypes.func.isRequired,
  dateRanges: PropTypes.arrayOf(
    PropTypes.shape({
      dateFrom: PropTypes.instanceOf(Moment),
      dateTo: PropTypes.instanceOf(Moment)
    })
  )
};

const roomKindsSignature = rks => rks.map(r => r.id).join(";");

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StayDataForm);
